(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-paypal-button", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-paypal-button"] = factory(require("react"));
	else
		root["react-paypal-button"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PayPalButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PayPalButton", function() { return _PayPalButton__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types__WEBPACK_IMPORTED_MODULE_1__) if(["PayPalButton","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _types__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PayPalButtonBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);




function PayPalButton(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__["default"], null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_PayPalButtonBase__WEBPACK_IMPORTED_MODULE_1__["default"], props));
}

/* harmony default export */ __webpack_exports__["default"] = (PayPalButton);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);



function PayPalButtonBase(props) {
  var _usePaypalScript = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["usePaypalScript"])(props.paypalOptions),
      loading = _usePaypalScript.loading,
      done = _usePaypalScript.done;

  var options = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["usePaypalScriptOptions"])(props);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var hasWindow = window !== undefined && window.paypal !== undefined;

    if (hasWindow) {
      // check to support SSR
      if (!loading && done) {
        try {
          window.paypal.Buttons(options).render('#paypal-button');
        } catch (e) {
          console.error(_utils__WEBPACK_IMPORTED_MODULE_1__["scriptLoadError"]);
        }
      }
    }
  }, [loading, done]);
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    id: "paypal-button"
  });
}

/* harmony default export */ __webpack_exports__["default"] = (PayPalButtonBase);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _usePaypalMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "usePaypalMethods", function() { return _usePaypalMethods__WEBPACK_IMPORTED_MODULE_0__["usePaypalMethods"]; });

/* harmony import */ var _usePaypalScript__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "usePaypalScript", function() { return _usePaypalScript__WEBPACK_IMPORTED_MODULE_1__["usePaypalScript"]; });

/* harmony import */ var _usePaypalScriptOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "usePaypalScriptOptions", function() { return _usePaypalScriptOptions__WEBPACK_IMPORTED_MODULE_2__["usePaypalScriptOptions"]; });

/* harmony import */ var _composeUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "composeUrl", function() { return _composeUrl__WEBPACK_IMPORTED_MODULE_3__["composeUrl"]; });

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scriptLoadError", function() { return _constants__WEBPACK_IMPORTED_MODULE_4__["scriptLoadError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "authError", function() { return _constants__WEBPACK_IMPORTED_MODULE_4__["authError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "captureError", function() { return _constants__WEBPACK_IMPORTED_MODULE_4__["captureError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "baseUrl", function() { return _constants__WEBPACK_IMPORTED_MODULE_4__["baseUrl"]; });







/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usePaypalMethods", function() { return usePaypalMethods; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);


function usePaypalMethods(props) {
  var onError = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data) {
    if (props.onPaymentError) {
      props.onPaymentError(data.message);
    }
  }, []);
  var createOrder = props.paypalOptions.vault ? null : Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data, actions) {
    if (props.onPaymentStart) {
      props.onPaymentStart();
    }

    return actions.order.create({
      purchase_units: [{
        amount: {
          value: props.amount
        }
      }]
    });
  }, [props.amount]);
  var createSubscription = !props.paypalOptions.vault ? null : Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data, actions) {
    if (props.paypalOptions.vault && props.subsciptionPlanId) {
      return actions.subscription.create({
        plan_id: props.subsciptionPlanId
      });
    }
  }, []);
  var onApprove = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data, actions) {
    if (props.paypalOptions.vault && props.subsciptionPlanId) {
      if (props.onPaymentSuccess) {
        props.onPaymentSuccess(data);
      }
    }

    if (props.paypalOptions.intent === 'capture') {
      return actions.order.capture().then(function (details) {
        if (props.onPaymentSuccess) {
          props.onPaymentSuccess(details);
        }
      })["catch"](function (e) {
        if (props.onPaymentError) {
          props.onPaymentError(e);
        }

        console.error(_constants__WEBPACK_IMPORTED_MODULE_1__["captureError"], "\n          Original error message: ".concat(e.message, "\n        "));
      });
    }

    if (props.paypalOptions.intent === 'authorize') {
      actions.order.authorize().then(function (auth) {
        var id = auth.purchase_units[0].payments.authorizations[0].id;

        if (props.onApprove !== undefined) {
          props.onApprove(data, id);
        }
      })["catch"](function (e) {
        if (props.onPaymentError) {
          props.onPaymentError(e);
        }

        console.error(_constants__WEBPACK_IMPORTED_MODULE_1__["authError"], "\n          Original error message: ".concat(e.message, "\n        "));
      });
    }
  }, []);
  var payment = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data, actions) {
    return actions.payment.create({
      transactions: [{
        amount: {
          total: props.amount,
          currency: props.paypalOptions.currency
        }
      }]
    });
  }, []);
  var onShippingChange = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data, actions) {
    if (props.onShippingChange) {
      Promise.resolve(props.onShippingChange(data)).then(function (rate) {
        // early exit if user doesn't return a value
        if (!rate) {
          return actions.resolve();
        } // otherwise tell paypal to update the total


        var baseOrderAmount = "".concat(props.amount);
        var shippingAmount = "".concat(rate);
        var value = (parseFloat(baseOrderAmount) + parseFloat(shippingAmount)).toFixed(2);
        var currency_code = props.paypalOptions.currency;
        return actions.order.patch([{
          op: 'replace',
          path: '/purchase_units/@reference_id==\'default\'/amount',
          value: {
            currency_code: currency_code,
            value: value,
            breakdown: {
              item_total: {
                currency_code: currency_code,
                value: baseOrderAmount
              },
              shipping: {
                currency_code: currency_code,
                value: shippingAmount
              }
            }
          }
        }]);
      });
    } else {
      return actions.resolve();
    }
  }, []);
  var onCancel = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (data) {
    if (props.onPaymentCancel) {
      props.onPaymentCancel(data);
    }
  }, []);
  return {
    createOrder: createOrder,
    createSubscription: createSubscription,
    onApprove: onApprove,
    onCancel: onCancel,
    onError: onError,
    onShippingChange: onShippingChange,
    payment: payment
  };
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scriptLoadError", function() { return scriptLoadError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authError", function() { return authError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "captureError", function() { return captureError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseUrl", function() { return baseUrl; });
var scriptLoadError = "\n  React-paypal-button loading script error:\n\n  Make sure that that your clientID is correct and that you are passing valid values to the paypalOptions prop and the buttonStyles prop.\n\n  For a list of valid properties for paypalOptions see https://developer.paypal.com/docs/checkout/reference/customize-sdk/#query-parameters\n  For a list of valid properties for buttonStyles see https://developer.paypal.com/docs/checkout/integration-features/customize-button/#color\n";
var authError = "\n  React-paypal-button authorization error:\n\n  This is likely an issue with paypal's api and the way they are handling their session data.\n  Try closing and reopening your browser\n";
var captureError = "\n  React-paypal-button capture error:\n\n  This is likely an issue with paypal's api and the way they are handling their session data.\n  Try closing and reopening your browser\n";
var baseUrl = 'https://www.paypal.com/sdk/js';

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usePaypalScript", function() { return usePaypalScript; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);



function usePaypalScript(options) {
  var scriptCache = [];
  var url = Object(___WEBPACK_IMPORTED_MODULE_2__["composeUrl"])(options);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(true),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      _useState4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      _useState6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState5, 2),
      done = _useState6[0],
      setDone = _useState6[1];

  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    // early exit if cache is in script
    if (scriptCache.includes(url)) {
      setLoading(false);
      setDone(true), setError(false);
    } else {
      scriptCache.push(url);
    }

    var script = document.createElement('script');
    script.src = url;
    script.async = true;

    var onScriptLoad = function onScriptLoad() {
      setLoading(false);
      setDone(true), setError(false);
    };

    var onScriptError = function onScriptError() {
      // if we error out, retry by removing the url from the cache
      var urlIndex = scriptCache.indexOf(url);

      if (urlIndex !== -1) {
        scriptCache.splice(urlIndex, 1);
        script.remove();
      }

      console.error(___WEBPACK_IMPORTED_MODULE_2__["scriptLoadError"]);
      setLoading(false);
      setDone(true), setError(true);
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);
    document.body.appendChild(script);
    return function () {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
    }; // rerun if url changes
  }, [url]);
  return {
    loading: loading,
    error: error,
    done: done
  };
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(9);

var iterableToArrayLimit = __webpack_require__(10);

var nonIterableRest = __webpack_require__(11);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usePaypalScriptOptions", function() { return usePaypalScriptOptions; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);

function usePaypalScriptOptions(props) {
  var style = props.buttonStyles,
      amount = props.amount;

  var _usePaypalMethods = Object(___WEBPACK_IMPORTED_MODULE_0__["usePaypalMethods"])(props),
      createOrder = _usePaypalMethods.createOrder,
      createSubscription = _usePaypalMethods.createSubscription,
      onApprove = _usePaypalMethods.onApprove,
      onCancel = _usePaypalMethods.onCancel,
      onError = _usePaypalMethods.onError,
      onShippingChange = _usePaypalMethods.onShippingChange,
      payment = _usePaypalMethods.payment;

  return {
    style: style,
    amount: amount,
    createOrder: createOrder,
    createSubscription: createSubscription,
    onApprove: onApprove,
    onCancel: onCancel,
    onError: onError,
    onShippingChange: onShippingChange,
    payment: payment
  };
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composeUrl", function() { return composeUrl; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);

var composeUrl = function composeUrl(options) {
  var queryString = Object.keys(options).reduce(function (prevParams, currentValue, index) {
    var convertKeyFromCamelCaseToDash = currentValue.split(/(?=[A-Z])/).join('-').toLowerCase(); // for disableCard or disableFunding prop convert array to comma seperated string
    // else return the value

    var value = currentValue === 'disableCard' || currentValue === 'disableFunding' ? options[currentValue].join(',') : options[currentValue]; // add an '&' symbol for all except the first key value pair

    var keyValuePair = "".concat(index === 0 ? '' : '&').concat(convertKeyFromCamelCaseToDash, "=").concat(value);
    return "".concat(prevParams).concat(keyValuePair);
  }, '?');
  var url = "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__["baseUrl"]).concat(queryString);
  return url;
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);









var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _getPrototypeOf2;

    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, (_getPrototypeOf2 = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "state", {
      hasError: false
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "setError", function () {
      _this.setState({
        hasError: true
      });
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      this.setError();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return null;
      } else {
        return this.props.children;
      }
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (ErrorBoundary);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(18);

var assertThisInitialized = __webpack_require__(19);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(22);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 24 */
/***/ (function(module, exports) {



/***/ })
/******/ ]);
});